module.exports = __webpack_public_path__ + "img/msg.0f644f61.png";